/**
 * Stash for the DOM element that opened the Login modal so we can return
 * focus to it (or its replacement) when the modal closes.
 *
 * Why a module-level variable: the trigger button (Login) is
 * gated in Header.tsx on `!displayLogIn`. As soon as showLogIn() dispatches,
 * Header re-renders without the utility container, so by the time Login's
 * componentDidMount fires, the button is no longer in the DOM and
 * document.activeElement has fallen back to <body>. Capturing the element
 * synchronously inside the click handler (before showLogIn() triggers the
 * unmount) is the only place we still have a reference to it.
 *
 * On close, the login button is RE-mounted under the same selector, so we
 * query for it again rather than reusing the stale reference.
 */
let lastLoginTrigger: HTMLElement | null = null;

export function captureLoginTrigger(el: HTMLElement | null): void {
  lastLoginTrigger = el;
}

export function getLoginTriggerSelector(): string {
  // Both the new functional Header and legacy class Header expose the
  // login trigger under one of these classes.
  return "button.nav-utility-link-account, button.header-login-btn";
}

/**
 * Try the captured element first (still valid if Header didn't unmount it),
 * fall back to a fresh selector lookup, then clear the slot.
 */
export function consumeLoginTrigger(): HTMLElement | null {
  let el = lastLoginTrigger && document.body.contains(lastLoginTrigger)
    ? lastLoginTrigger
    : (document.querySelector(getLoginTriggerSelector()) as HTMLElement | null);
  lastLoginTrigger = null;
  return el;
}
